module.exports = __webpack_public_path__ + "img/tool-2.8c8247dc.png";